import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { catchError, Observable } from 'rxjs';

import { Invoice, LoginInvoice } from 'src/app/models/invoice.interface';
import { Utility } from 'src/app/helpers/utility-helper';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService {
  constructor(
    private http: HttpClient
  ) {
    this.login = {
      invoiceId: 0,
      transactionId: 0,
    };

    this.invoice = {
      address1: '',
      address2: '',
      addressTypeId: 0,
      businessName: '',
      businessId: '',
      businessTaxId: '',
      city: '',
      dueDate: '',
      remainingDueDays: 0,
      emailAddress: '',
      emailAddressTypeId: 0,
      firstName: '',
      localFirstSentDateTime: '',
      firstViewedDateTime: '',
      invoiceNumber: 0,
      lastName: '',
      lastViewedDateTime: '',
      middleInitial: '',
      phoneNumber: '',
      phoneTypeId: 0,
      prefixId: 0,
      sendEmail: false,
      sendText: false,
      stateId: 0,
      stateName: '',
      countryCode: '',
      suffixId: 0,
      zip: '',
      address: ''
    };
  }

  public login: LoginInvoice;
  public invoice: Invoice;

  postLoginInvoice(InvoiceTrackingKey: string): Observable<LoginInvoice> {
    return this.http.post<LoginInvoice>('api/invoices/login', {
      InvoiceTrackingKey,
    });
  }

  postNotification(notificationInfo: any): Observable<any> {
    return this.http.post(
      'api/invoices/' + notificationInfo.invoiceId + '/notification',
      {
        InvoiceNotificationTypeId: notificationInfo.InvoiceNotificationTypeId,
        NotificationChannelTypeIds: notificationInfo.NotificationChannelTypeIds,
        Phone: notificationInfo.Phone,
        Email: notificationInfo.Email,
        IsMerchantCommunication: notificationInfo.IsMerchantCommunication,
        LanguageCode: notificationInfo.LanguageCode,
      }
    );
  }

  getInvoice(invoiceId: number): Observable<Invoice> {
    return this.http.get<Invoice>('api/invoices/' + invoiceId);
  }

  patchInvoice(
    invoiceId: number,
    firstViewedDateTime?: string | null,
    lastViewedDateTime?: string | null,
    InvoiceStateTypeId?: number | null
  ): Observable<any> {
    return this.http
      .patch('api/invoices/' + invoiceId, {
        firstViewedDateTime,
        lastViewedDateTime,
        InvoiceStateTypeId,
      })
      .pipe(catchError(() => Utility.okHttpResponse()));
  }

  setLoginData(login: LoginInvoice): void {
    this.login = login;
  }

  setInvoiceData(invoice: Invoice): void {
    this.invoice = invoice;
  }
}
